"use strict";

var _regeneratorRuntime = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var scenario_selectors_1 = require("../../redux/scenario/scenario.selectors");

var scenario_selectors_2 = require("../../redux/scenario/scenario.selectors");

var deploy_scenario_button_component_1 = __importDefault(require("./deploy-scenario-button.component"));

var DeployScenarioButtonContainer = function DeployScenarioButtonContainer(_ref) {
  var deploy = _ref.deploy,
      save = _ref.save;
  var nodeMap = react_redux_1.useSelector(scenario_selectors_1.selectNodeMap);
  var keywordsMap = react_redux_1.useSelector(scenario_selectors_1.selectKeywordsMap);
  var parsedNodeMap = react_redux_1.useSelector(scenario_selectors_1.selectParsedNodeMap);
  var searchKeywords = react_redux_1.useSelector(scenario_selectors_1.selectSearchKeywords);
  var isValidNodeMap = react_redux_1.useSelector(scenario_selectors_2.selectIsValidNodeMap);
  return react_1.default.createElement(deploy_scenario_button_component_1.default, {
    handleDeployScenario: function handleDeployScenario() {
      return _regeneratorRuntime.async(function handleDeployScenario$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _regeneratorRuntime.awrap(save(nodeMap, keywordsMap));

            case 2:
              _context.next = 4;
              return _regeneratorRuntime.awrap(deploy(parsedNodeMap, searchKeywords));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      });
    },
    disabled: !isValidNodeMap
  });
};

exports.default = DeployScenarioButtonContainer;